import { defineRule } from 'vee-validate'
import { validateCardCvv, validateCardExpiryDate, validateCardNumber, validateCardHolderName } from '@eonx-com/payment-elements'

defineRule('required', (value?: string) => {
  return !!String(value || '').trim().length || 'Is required'
})

defineRule('min', (value: string, params, ctx) => {
  const field = ctx.field
  const minLength = params instanceof Array ? params[0] : undefined

  if (!minLength) {
    console.error(`Min length is not specified for min rule in ${field} field`)
    return false
  }

  return String(value || '').trim().length >= Number(minLength) || `Should contain at least ${minLength} characters`
})

defineRule('cardExpiry', (value: string) => {
  return validateCardExpiryDate(value)
})

defineRule('cardExpiryFull', (value: string) => {
  return validateCardExpiryDate(value, true)
})

defineRule('cardNumber', (value: string, cardTypes: string[] | undefined) => {
  return validateCardNumber(value, cardTypes ?? [])
})

defineRule('cardCvv', (value: string, _, { form }) => {
  return validateCardCvv(form.number as string, value)
})

defineRule('cardHolderName', (value: string) => {
  return validateCardHolderName(value)
})

defineRule('json', (value: string) => {
  if (!value) return true

  try {
    JSON.parse(value)
    return true
  } catch (_) {
    return 'Invalid JSON'
  }
})
